import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | undefined;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-md border border-linen bg-white px-3 py-2 text-sm font-sans text-forge',
        'placeholder:text-steel',
        'focus:outline-none focus:ring-2 focus:ring-copper focus:border-copper',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        error && 'border-rust focus:ring-rust',
        className
      )}
      {...props}
    />
  )
);
Input.displayName = 'Input';

export { Input };
